import React from 'react'
import { useCacheClient, getPointsOfSaleForSelect, getProjectsForSelect } from '../../../../hooks/cache/client'
import { Space, Switch, Select } from 'antd'

const Filters = (props) => {
  const { filters } = props
  const { data: clientsRaw, isLoading, isError } = useCacheClient()

  const projects = getProjectsForSelect(clientsRaw)
  const pointsOfSale = getPointsOfSaleForSelect(clientsRaw)

  const isActiveJobs = filters ? filters.activeJobs == 1 : false
  const isUncompensated = filters ? filters.uncompensatedVendor == 1 : false

  const project = filters ? (filters.project ? parseInt(filters.project) : undefined) : undefined
  const pointOfSale = filters ? (filters.pointOfSale ? parseInt(filters.pointOfSale) : undefined) : undefined
  //const component = filters ? (filters.component ? parseInt(filters.component) : undefined) : undefined;

  const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0

  const _updateCompensated = (bool) => {
    if (bool) {
      return props.onUpdateFilters({ activeJobs: 0, uncompensatedVendor: 1 })
    }

    return props.onUpdateFilters({ uncompensatedVendor: 0 })
  }

  if (isLoading || isError) {
    return null
  }

  return (
    <>
      <Space size='small'>
        <Switch
          checked={isActiveJobs}
          size='small'
          onChange={(bool) => props.onUpdateFilters({ activeJobs: bool ? 1 : 0 })}
        />{' '}
        Actives
        <Switch checked={isUncompensated} size='small' onChange={_updateCompensated} /> Uncompensated
      </Space>
      <br />
      <br />
      <Space size='small'>
        <Select
          placeholder='Project'
          allowClear
          name='Project'
          size='small'
          showSearch
          options={projects}
          filterOption={_filter}
          style={{ minWidth: '150px' }}
          value={project}
          onChange={(e) => {
            props.onUpdateFilters({ project: e ? e : undefined })
          }}
        />
        <Select
          placeholder='Point Of Sale'
          allowClear
          name='pointOfSale'
          size='small'
          showSearch
          options={pointsOfSale}
          filterOption={_filter}
          style={{ minWidth: '150px' }}
          value={pointOfSale}
          onChange={(e) => {
            props.onUpdateFilters({ pointOfSale: e ? e : undefined })
          }}
        />
        {/*
        <Select
            placeholder="Component"
            allowClear
            name="component"
            size="small"
            showSearch
            options={props.components}
            filterOption={_filter}
            style={{ minWidth: "150px" }}
            value={component}
            onChange={(e) => {
                props.onUpdateFilters({ component: e ? e : undefined });
            }}
        />
        <Button type="link" htmlType="button">
            Reset Filters
        </Button>
        */}
      </Space>
    </>
  )
}

export default Filters
